const {
  FINANCIAL_REPORT_FETCH_LOADING,
  FINANCIAL_REPORT_FETCH_SUCCESS,
  FINANCIAL_REPORT_FETCH_ERROR,
  FINANCIAL_REPORT_FETCH_ACTION,
} = require("../types");

const initialState = {
  loading: false,
  page_loading: false,
  result: [],
  error: "",
};

const financialReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case FINANCIAL_REPORT_FETCH_LOADING:
      return {
        ...state,
        loading: action.payload,
        error: "",
      };
    case FINANCIAL_REPORT_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload,
        error: "",
      };
    case FINANCIAL_REPORT_FETCH_ERROR:
      return {
        ...state,
        loading: false,
        result: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default financialReportReducer;
